import { ProgramType } from '../ProgramTypes';

import { PayoutEvent } from './Events';

export const PayoutEventMap: Record<
  ProgramType,
  Array<{
    event: PayoutEvent;
    name: string;
    order: number;
    badgeVariant: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'warning' | 'info' | 'success' | 'default'; //BadgeVariant from palmetto-components
  }>
> = {
  [ProgramType.solar]: [
    { event: PayoutEvent.noticeToProceed, name: 'NTP', order: 1, badgeVariant: 'warning' },
    { event: PayoutEvent.noticeToProceedPlus, name: 'NTP+', order: 2, badgeVariant: 'danger' },
    { event: PayoutEvent.installSubmitted, name: 'Install Submitted', order: 3, badgeVariant: 'tertiary' },
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 4, badgeVariant: 'secondary' },
    { event: PayoutEvent.ptoApproved, name: 'PTO Approved', order: 5, badgeVariant: 'primary' },
    { event: PayoutEvent.activationApproved, name: 'Activation Approved', order: 6, badgeVariant: 'primary' },
    { event: PayoutEvent.estimate, name: 'Materials Estimate', order: 9, badgeVariant: 'secondary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 10, badgeVariant: 'primary' },
    { event: PayoutEvent.warranty, name: 'Warranty', order: 11, badgeVariant: 'info' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 12, badgeVariant: 'default' },
    { event: PayoutEvent.domesticContentHoldback, name: 'DC Holdback', order: 13, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 14, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 15, badgeVariant: 'default' },
    { event: PayoutEvent.propertyType, name: 'Property Type', order: 16, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.doePr]: [
    { event: PayoutEvent.noticeToProceed, name: 'NTP', order: 1, badgeVariant: 'warning' },
    { event: PayoutEvent.noticeToProceedPlus, name: 'NTP+', order: 2, badgeVariant: 'danger' },
    { event: PayoutEvent.installSubmitted, name: 'Install Submitted', order: 3, badgeVariant: 'tertiary' },
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 4, badgeVariant: 'secondary' },
    { event: PayoutEvent.activationApproved, name: 'Activation Approved', order: 5, badgeVariant: 'primary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 7, badgeVariant: 'primary' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 8, badgeVariant: 'default' },
    { event: PayoutEvent.domesticContentHoldback, name: 'DC Holdback', order: 9, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 10, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 11, badgeVariant: 'default' },
    { event: PayoutEvent.propertyType, name: 'Property Type', order: 16, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.hvac]: [
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 1, badgeVariant: 'secondary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 2, badgeVariant: 'primary' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 3, badgeVariant: 'default' },
    { event: PayoutEvent.domesticContentHoldback, name: 'DC Holdback', order: 4, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 5, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 6, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.waterHeater]: [
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 1, badgeVariant: 'secondary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 2, badgeVariant: 'primary' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 3, badgeVariant: 'default' },
    { event: PayoutEvent.domesticContentHoldback, name: 'DC Holdback', order: 4, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 5, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 6, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.generator]: [
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 1, badgeVariant: 'secondary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 2, badgeVariant: 'primary' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 3, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 5, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 6, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.newHomes]: [
    { event: PayoutEvent.noticeToProceed, name: 'NTP', order: 1, badgeVariant: 'warning' },
    { event: PayoutEvent.noticeToProceedPlus, name: 'NTP+', order: 2, badgeVariant: 'danger' },
    { event: PayoutEvent.installSubmitted, name: 'Install Submitted', order: 3, badgeVariant: 'tertiary' },
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 4, badgeVariant: 'secondary' },
    { event: PayoutEvent.ptoApproved, name: 'PTO Approved', order: 5, badgeVariant: 'primary' },
    { event: PayoutEvent.activationApproved, name: 'Activation Approved', order: 6, badgeVariant: 'primary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 10, badgeVariant: 'primary' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 11, badgeVariant: 'default' },
    { event: PayoutEvent.domesticContentHoldback, name: 'DC Holdback', order: 12, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 13, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 14, badgeVariant: 'default' },
    { event: PayoutEvent.propertyType, name: 'Property Type', order: 16, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.newCommunity]: [
    { event: PayoutEvent.installSubmitted, name: 'Install Submitted', order: 1, badgeVariant: 'tertiary' },
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 2, badgeVariant: 'secondary' },
    { event: PayoutEvent.activationApproved, name: 'Activation Approved', order: 3, badgeVariant: 'primary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 10, badgeVariant: 'primary' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 11, badgeVariant: 'default' },
    { event: PayoutEvent.domesticContentHoldback, name: 'DC Holdback', order: 12, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 13, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 14, badgeVariant: 'default' },
    { event: PayoutEvent.propertyType, name: 'Property Type', order: 16, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.energyBackup]: [
    { event: PayoutEvent.installSubmitted, name: 'Install Submitted', order: 3, badgeVariant: 'tertiary' },
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 4, badgeVariant: 'secondary' },
    { event: PayoutEvent.ptoApproved, name: 'PTO Approved', order: 5, badgeVariant: 'primary' },
    { event: PayoutEvent.activationApproved, name: 'Activation Approved', order: 6, badgeVariant: 'primary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 10, badgeVariant: 'primary' },
    { event: PayoutEvent.standardHoldback, name: 'Standard Holdback', order: 11, badgeVariant: 'default' },
    { event: PayoutEvent.domesticContentHoldback, name: 'DC Holdback', order: 12, badgeVariant: 'default' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 13, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 14, badgeVariant: 'default' },
    { event: PayoutEvent.propertyType, name: 'Property Type', order: 16, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.geothermal]: [
    { event: PayoutEvent.noticeToProceed, name: 'NTP', order: 1, badgeVariant: 'warning' },
    { event: PayoutEvent.loopFieldApproved, name: 'Loop Field Approved', order: 2, badgeVariant: 'info' },
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 3, badgeVariant: 'secondary' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
  [ProgramType.consumerSolar]: [
    { event: PayoutEvent.siteSurvey, name: 'Site Survey', order: 0, badgeVariant: 'info' },
    { event: PayoutEvent.siteSurveyApproved, name: 'Site Survey Approved', order: 1, badgeVariant: 'info' },
    { event: PayoutEvent.installSubmitted, name: 'Install Submitted', order: 2, badgeVariant: 'tertiary' },
    { event: PayoutEvent.installApproved, name: 'Install Approved', order: 3, badgeVariant: 'secondary' },
    { event: PayoutEvent.ptoApproved, name: 'PTO Approved', order: 4, badgeVariant: 'primary' },
    { event: PayoutEvent.activationApproved, name: 'Activation Approved', order: 5, badgeVariant: 'primary' },
    { event: PayoutEvent.invoice, name: 'Materials Invoice', order: 10, badgeVariant: 'primary' },
    { event: PayoutEvent.equipment, name: 'Equipment', order: 13, badgeVariant: 'default' },
    { event: PayoutEvent.shipping, name: 'Shipping', order: 14, badgeVariant: 'default' },
    { event: PayoutEvent.other, name: 'Other', order: 99, badgeVariant: 'default' },
  ],
};

export const PayoutsMaterialsEventType: Array<{
  event: PayoutEvent;
  name: string;
}> = [
  { event: PayoutEvent.estimate, name: 'Materials Estimate' },
  { event: PayoutEvent.invoice, name: 'Materials Invoice' },
];
